import Record from '../Record'

export default class Storage extends Record {

	constructor (data) {
		super(data)
		return this._proxy
	}

	static async fetch (company_db_id = null, id = null) {
		if (company_db_id == null || id == null) {
			// Create record
			throw new Error('New storage cannot be created')
		} else {
			// Load
			let data = await Anvil.REST.get(`/c_order/storage/${company_db_id}/${id}`)
			return new Storage(data)
		}
	}

	static async delete (id) {
        throw new Error('Storage cannot be deleted')
	}

	async commit () {
		if (this._data.id == null) {
			// Insert
            throw new Error('New storage cannot be created')
		} else {
			// Update
			await Anvil.REST.put(`/c_order/storage/${this._data.company_db_id}/${this._data.id}`, this._data)
		}
	}
}
